import { put } from "redux-saga/effects";
import importer from "common/importer";
const PublicContentActions = importer("Stores/PublicContent/Actions");
/**
 * PUBLIC_STARTUP_SUCCESS
 */
function* initializeAppSuccess() {
  // console.log('initializeAppSuccess')
  /**
   * GET APP IMAGES
   */
  yield put(PublicContentActions.getDrupalNavigation());
  yield put(PublicContentActions.getMessages());
  yield put(PublicContentActions.getCenters());
  yield put(PublicContentActions.getAllStates());
  yield put(PublicContentActions.getGenders());
  yield put(PublicContentActions.getCountries());
  yield put(PublicContentActions.getEthnicityOptions());
  yield put(PublicContentActions.getLoyaltyAchievementBadges());
}

export default initializeAppSuccess;
